"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Model for mapped objects.
 */
class MappedModelBase {
    /**
     * Gets value mapping for validation.
     *
     * @param {*} mapping
     * @return {*}
     */
    static getValueMapping(mapping) {
        return {
            type: "object",
            value: mapping,
        };
    }
}
exports.default = MappedModelBase;
